import h from 'react-hyperscript';
import hh from 'hyperscript-helpers';

import styles from './checkbox.css';

const { input, label, div } = hh(h);

const Checkbox = (props) => (
    div({className: styles.container}, [
        input({
            id: props.id,
            className: styles.input,
            required: props.required,
            readOnly: props.readonly,
            onChange: (event) => props.onChange(event.target.checked),
            type: 'checkbox'
        }),
        label({className: styles.label, htmlFor: props.id})])
);

export default Checkbox;



/** WEBPACK FOOTER **
 ** ./src/ApplicationForm/Checkbox.js
 **/